import Vue from "vue";

const state = {
  messages: [], //存当前消息列表
  privateSessionList: [], // 私聊会话列表
  groupSessionId: "", // 群聊会话ID
  currentSession: {}, // 当前私聊会话信息
  tabList: [
    { name: "班级消息", value: "group" },
    { name: "私聊消息", value: "C2C" },
  ], // 聊天tab列表
  activeTab: "group", // 当前激活tab
  showChat: false, //是否显示聊天
  userInfo: {
    user_id: "",
    isTeacher: false,
    isAssistant: false,
    user_name: "",
    user_role: 3,
  }, // 当前用户信息
  selectedMember: "all", // 发送至：当前选中的成员
  haveMaterialPermission: false, // 是否有素材中心权限
  replayMessage: null, // 引用消息
  liveInfo: {
    teacher_id: "",
    assistant_teacher_id: "",
  }, // 直播信息
  onlyShowTeacher: false, // 是否只看老师
  hasMoreMessages: true, // 是否还有更多消息
  chatMode: "embed", // embed/popup(桌面端消息模式)
  privateUnread: 0, // 私聊未读消息总数
  downloadInfo: {}, // 正在下载文件信息
  downloadedFileList: [], // 已下载文件列表
  defaultDownloadPath: "", // 默认下载路径
  // Web下载全局管理 - 使用消息ID作为key
  webDownloadInfo: {}, // Web下载信息 { messageId: { progress, speed, fileName, url, failed, error } }
  webDownloadControllers: {}, // 全局下载控制器 { messageId: AbortController }
  webDownloadReaders: {}, // 全局下载读取器 { messageId: ReadableStreamDefaultReader }
  syncedFirstMessageId: null, // 记录同步到聊天窗口的消息列表的第一项消息的ID
};

const mutations = {
  UPDATE_DOWNLOADED_FILE_LIST(state, list) {
    state.downloadedFileList = [...state.downloadedFileList, ...list];
    Vue.set(state, "downloadedFileList", state.downloadedFileList);
  },
  SET_DOWNLOADED_FILE_LIST(state, list) {
    state.downloadedFileList = list || [];
    Vue.set(state, "downloadedFileList", state.downloadedFileList);
  },
  SET_DEFAULT_DOWNLOAD_PATH(state, path) {
    state.defaultDownloadPath = path;
  },
  SET_DOWNLOAD_INFO(state, obj) {
    state.downloadInfo = {
      ...state.downloadInfo,
      ...obj,
    };
  },
  DELETE_DOWNLOAD_INFO(state, im_msg_key) {
    delete state.downloadInfo[im_msg_key];
    Vue.set(state.downloadInfo, im_msg_key, undefined);
  },
  // Web下载相关mutations
  SET_WEB_DOWNLOAD_INFO(state, { messageId, info }) {
    Vue.set(state.webDownloadInfo, messageId, {
      ...state.webDownloadInfo[messageId],
      ...info,
    });
  },
  DELETE_WEB_DOWNLOAD_INFO(state, messageId) {
    delete state.webDownloadInfo[messageId];
    Vue.set(state.webDownloadInfo, messageId, undefined);
  },
  CLEAR_ALL_WEB_DOWNLOADS(state) {
    // 清理所有Web下载状态
    state.webDownloadInfo = {};
  },
  // 下载控制器和读取器管理
  SET_WEB_DOWNLOAD_CONTROLLER(state, { messageId, controller }) {
    Vue.set(state.webDownloadControllers, messageId, controller);
  },
  DELETE_WEB_DOWNLOAD_CONTROLLER(state, messageId) {
    delete state.webDownloadControllers[messageId];
    Vue.set(state.webDownloadControllers, messageId, undefined);
  },
  SET_WEB_DOWNLOAD_READER(state, { messageId, reader }) {
    Vue.set(state.webDownloadReaders, messageId, reader);
  },
  DELETE_WEB_DOWNLOAD_READER(state, messageId) {
    delete state.webDownloadReaders[messageId];
    Vue.set(state.webDownloadReaders, messageId, undefined);
  },
  SET_SYNCED_FIRST_MESSAGE_ID(state, messageId) {
    state.syncedFirstMessageId = messageId;
  },
  SET_PRIVATE_UNREAD(state, unread) {
    state.privateUnread = unread;
  },
  SET_CHAT_MODE(state, mode) {
    state.chatMode = mode;
  },
  SET_PRIVATE_SESSION_LIST(state, list) {
    state.privateSessionList = list;
  },
  SET_HAS_MORE_MESSAGES(state, value) {
    state.hasMoreMessages = value;
  },
  SET_ONLY_SHOW_TEACHER(state, value) {
    state.onlyShowTeacher = value;
  },
  SET_LIVE_INFO(state, liveInfo) {
    state.liveInfo = { ...state.liveInfo, ...liveInfo };
  },
  SET_REPLAY_MESSAGE(state, message) {
    state.replayMessage = message;
  },
  SET_HAVE_MATERIAL_PERMISSION(state, permission) {
    state.haveMaterialPermission = permission;
  },
  SET_SELECTED_MEMBER(state, member) {
    state.selectedMember = member || "all";
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = { ...state.userInfo, ...userInfo };
  },
  // 全量同步
  SET_FULL_STATE(state, payload) {
    Object.assign(state, payload);
  },
  // 设置群聊会话ID
  SET_GROUP_SESSION_ID(state, id) {
    state.groupSessionId = id;
  },
  // 编辑消息（撤回/内容修改）
  EDIT_MESSAGE(state, { messageId, data }) {
    if (state.messages[messageId]) {
      Object.assign(state.messages[messageId], data);
    }
  },
  // 删除消息
  DELETE_MESSAGE(state, { messageId, sessionId }) {
    if (state.messages[messageId]) {
      delete state.messages[messageId];
      const session = state.sessions[sessionId];
      if (session) {
        session.messages = session.messages.filter((id) => id !== messageId);
      }
    }
  },
  // 设置当前会话
  SET_CURRENT_SESSION(state, conversation) {
    state.currentSession = { ...conversation };
  },
  SET_ACTIVE_TAB(state, tabValue) {
    state.activeTab = tabValue;
  },
  SET_SHOW_CHAT(state, value) {
    state.showChat = value;
  },
  // 新增消息
  ADD_MESSAGE(state, message) {
    state.messages.push(message);
  },
  // 设置消息列表（覆盖）
  SET_MESSAGES(state, messages) {
    state.messages = messages;
  },
  // 批量添加消息
  ADD_MESSAGES(state, { messages, isHistoryMessages = false }) {
    if (isHistoryMessages) {
      // 历史消息添加到前面（按时间顺序）
      state.messages = [...messages, ...state.messages];
    } else {
      // 新消息添加到后面
      state.messages = [...state.messages, ...messages];
    }
  },
  // 更新消息状态
  UPDATE_MESSAGE(state, message) {
    const { ID } = message;
    // 从后向前查找，通常最新的消息会在数组末尾
    for (let i = state.messages.length - 1; i >= 0; i--) {
      if (state.messages[i].ID === ID) {
        // 用 Vue.set 替换整个对象，保证响应式
        Vue.set(state.messages, i, { ...state.messages[i], ...message });
        break; // 找到后立即退出循环
      }
    }
  },
};

const actions = {
  // 增量事件处理
  handleIpcEvent({ commit }, event) {
    switch (event.type) {
      case "message-add":
        commit("ADD_MESSAGE", event.payload.message);
        break;
      case "message-update":
        commit("UPDATE_MESSAGE", event.payload.message);
        break;
      case "message-edit":
        commit("EDIT_MESSAGE", {
          messageId: event.payload.messageId,
          data: event.payload,
        });
        break;
      case "message-delete":
        commit("DELETE_MESSAGE", {
          messageId: event.payload.messageId,
          sessionId: event.payload.sessionId,
        });
        break;
      // case "session-add":
      //   commit("ADD_SESSION", event.payload.session);
      //   break;
      case "session-update":
        commit("UPDATE_SESSION", {
          sessionId: event.payload.sessionId,
          data: event.payload.data,
        });
        break;
      case "state-full":
        commit("SET_FULL_STATE", event.payload);
        break;
      default:
        break;
    }
  },
  // 切换会话
  switchSession({ commit }, conversation) {
    commit("SET_CURRENT_SESSION", conversation);
  },
  setActiveTab({ commit }, tabValue) {
    commit("SET_ACTIVE_TAB", tabValue);
  },
  // 更新消息状态
  updateMessageStatus({ commit }, { ID, status, response }) {
    commit("UPDATE_MESSAGE_STATUS", { ID, status });
  },
};

const getters = {
  currentSessionId: (state) => state.currentSession?.user_id || "",
  showTab: (state) =>
    (state.userInfo?.isTeacher || state.userInfo?.isAssistant) &&
    state.privateSessionList.length > 0,
  // Web下载相关getters
  getWebDownloadInfo: (state) => (messageId) =>
    state.webDownloadInfo[messageId] || null,
  getWebDownloadProgress: (state) => (messageId) =>
    state.webDownloadInfo[messageId]?.progress || 0,
  getWebDownloadSpeed: (state) => (messageId) =>
    state.webDownloadInfo[messageId]?.speed || "0KB/s",
  getWebDownloadController: (state) => (messageId) =>
    state.webDownloadControllers[messageId] || null,
  getWebDownloadReader: (state) => (messageId) =>
    state.webDownloadReaders[messageId] || null,
  getWebDownloadFailed: (state) => (messageId) =>
    state.webDownloadInfo[messageId]?.failed || false,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
